<template>
    <div class="diagram-hand-item">
        <div class="diagram-hand-item-title" v-if="itemProps[itemType]">{{itemProps[itemType].text}}</div>
        <div class="diagram-item item-yin">
            <div class="d-box d-box-b"></div>
            <div class="d-box d-box-b"></div>
            <div class="d-box " :class="{'d-box-w': itemType == 'syin' || itemType == 'lyin', 'd-box-b': itemType == 'syang' || itemType == 'lyang'}"></div>
            <div class="d-box d-box-b"></div>
            <div class="d-box d-box-b"></div>
        </div>
        <div class="diagram-hand-icon">
            <i v-if="itemType == 'lyin'" class="iconfont icon-guanbi"></i>
            <i v-if="itemType == 'lyang'" class="iconfont icon-unselected"></i>
        </div>
        <div class="diagram-hand-text" v-if="itemProps[itemType]">{{itemProps[itemType].word}}</div>
    </div>
</template>

<script>
export default {
    name: 'DiagramHandItem',
    props: {
        itemType: {
            type: String,
            default() { return 'syin' } //syin, syang, lyin, lyang
        }
    },
    data() {
        return {
            itemProps: {
                syin: {text: '少阴', word: '（2背1字）'},
                syang: {text: '少阳', word: '（1背2字）'},
                lyin: {text: '老阴', word: '（0背3字）'},
                lyang: {text: '老阳', word: '（3背0字）'},
            }
        }
    }
}
</script>